'use strict';
import { observable } from 'mobx';
import { fetch } from '@/lib/fetchAPI';
import history from '@/lib/history';
import * as Cookies from 'js-cookie';
class LoginStore {
  @observable loginError = false;
  @observable userId;
  @observable authority;
  @observable userName;

  login(name, password) {
    fetch(
      `/api/user/login`,
      {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          username: name,
          password: password
        })
      },
      json => {
        if (json.code === 200) {
          this.loginError = false;
          this.authority = json.authority;
          this.userId = json.userId;
          this.userName = json.username;
          Cookies.set('token', json.token, {
            path: '/'
          });
          history.push('/');
        } else {
          this.loginError = true;
        }
      }
    );
  }

  self(cb) {
    fetch(`/api/user/self`, { method: 'GET' }, json => {
      if (json.code === 200) {
        this.loginError = false;
        this.authority = json.authority;
        this.userId = json.userId;
        this.userName = json.username;
        cb();
      } else {
        history.push('/login');
      }
    });
  }
}
export default new LoginStore();



// WEBPACK FOOTER //
// ./src/store/Login.js